import { render } from "./PasswordInput.vue?vue&type=template&id=ddfbbc70&scoped=true"
import script from "./PasswordInput.vue?vue&type=script&lang=ts"
export * from "./PasswordInput.vue?vue&type=script&lang=ts"

import "./PasswordInput.vue?vue&type=style&index=0&id=ddfbbc70&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ddfbbc70"

export default script